import { render, staticRenderFns } from "./class_read.vue?vue&type=template&id=3ea4abb9&scoped=true"
import script from "./class_read.vue?vue&type=script&lang=js"
export * from "./class_read.vue?vue&type=script&lang=js"
import style0 from "./class_read.vue?vue&type=style&index=0&id=3ea4abb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4abb9",
  null
  
)

export default component.exports